import ListeConversations from './ListeConversations';

/**
 * Les conversations fermées — #85, décision #30.
 *
 * **1 347 conversations y dorment.** Ce n'est pas qu'un filet anti-erreur : c'est
 * une archive réelle. Sans retour possible, un doigt qui dérape au pouce ferait
 * disparaître une conversation jusqu'au prochain passage au bureau — sur le canal
 * où une cliente attend une réponse.
 *
 * La même liste que la boîte de réception, sur l'autre dossier. La réouverture se
 * fait **depuis le fil**, symétriquement à la fermeture : on rouvre après avoir
 * relu, comme on ferme après avoir lu.
 */
export default function ConversationsFermees() {
    return <ListeConversations dossier="closed" />;
}
